import { Box } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";
import { formatApprovalLabel, getApprovalStatusMeta } from "../../data";
import { ApprovalActionsPopover } from "./approval-actions-popover";

const formatDateTime = (date, pattern = "MMM d, yyyy, h:mm a") => {
  if (!date) return "N/A";
  const parsed = parseISO(date);
  return isValid(parsed) ? format(parsed, pattern) : "N/A";
};

export const ApprovalColumns = [
  {
    accessorKey: "module",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Module</div>,
    cell: ({ row }) => (
      <Box>{formatApprovalLabel(row.original.module)}</Box>
    ),
  },
  {
    accessorKey: "action",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <div>
        <div
          style={{ fontSize: "0.85rem", fontWeight: 500, whiteSpace: "nowrap" }}
        >
          {formatApprovalLabel(row.original.action)}
        </div>
        <div style={{ fontSize: "0.75rem", color: "#6b7280", marginTop: 2 }}>
          {row.original.actionDetail}
        </div>
      </div>
    ),
  },
  {
    accessorKey: "initiatedByName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Initiated By</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.initiatedByName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "target",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Target</div>,
    cell: ({ row }) => (
      <div>
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {row.original.target ?? "N/A"}
        </div>
        <div style={{ fontSize: "0.75rem", color: "#6b7280" }}>
          {formatApprovalLabel(row.original.targetType)}
        </div>
      </div>
    ),
  },
  {
    accessorKey: "submittedAt",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Submitted</div>,
    cell: ({ row }) => (
      <div
        style={{ fontSize: "0.85rem", whiteSpace: "nowrap", color: "#6b7280" }}
      >
        {formatDateTime(row.original.submittedAt)}
      </div>
    ),
  },
  {
    accessorKey: "status",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const { bg, color, label } = getApprovalStatusMeta(row.original.status);
      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: bg,
            color,
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          {label}
        </Box>
      );
    },
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Action</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", cursor: "pointer" }}>
        <ApprovalActionsPopover item={row.original} />
      </div>
    ),
  },
];
